import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export default class AuthOrdersIndexRoute extends Route {
  @service declare store: Store;
  model() {
    return this.store.peekAll('order');
  }
}
